import defaultsDeep from 'lodash/defaultsDeep';
import { getGenericChartConfig } from 'JIX/highcharts/configs/generic_chart.js';

export function getStandardPieChartConfig(options = {}) {
    const default_config = getGenericChartConfig({
        title: {
            text: "Pie Chart",
        },
        chart: {
            type: 'pie',
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                shadow: true,
            },
        },
        tooltip: {
            headerFormat: '',
            pointFormatter: function() {
                const y_local = this.series.options.custom.getLocaleNumbers(this.y);
                return '<b>' + this.name + '</b>: ' + y_local;
            },
        },
    });

    // Mutates 'options' with any 'default_config' options
    // that are missing from 'options'
    defaultsDeep(options, default_config);

    return options;
}

export function getMobilePieChartConfig(options = {}) {
    const default_config = getGenericChartConfig({
        accessibility: {
            // The accessibility module messes with our custom class
            // for disabling mouse tracking, so we disable the module
            // for these charts, as we currently have no use of it anyway.
            enabled: false,
        },
        title: {
            text: "Mobile Pie Chart",
        },
        chart: {
            type: 'pie',
            borderWidth: 0,
        },
        plotOptions: {
            series: {
                enableMouseTracking: false,
            },
            pie: {
                dataLabels: {
                    enabled: false,
                },
                showInLegend: true,
            },
        },
        legend: {
            enabled: true,
            // There is currently no built-in way to disable mouse tracking
            // on chart legends, so we do it with CSS instead. This class
            // overwrites the default class 'highcharts-no-tooltip', which
            // does not actually seem to do anything.
            className: "highcharts-no-mouse-tracking",
        },
    });

    // Mutates 'options' with any 'default_config' options
    // that are missing from 'options'
    defaultsDeep(options, default_config);

    return options;
}
